// extracted by mini-css-extract-plugin
module.exports = {"home-battery-B":"B_home-battery-B__qxowa"};